import React from 'react';
import { Button } from '../../components';
import clsx from 'clsx';

function calculatePage(total, rowsPerPage) {
  return Math.floor((total - 1) / rowsPerPage) + 1;
}

export default function PaginationAction(props) {
  const { currentPage, total, rowsPerPage, onChange } = props;

  const pageBufferSize = 2;
  const allPages = calculatePage(total, rowsPerPage);

  const handleChange = (page) => {
    let newPage = page;
    if (page < 1) {
      newPage = 1;
    }
    onChange(newPage);
  };

  const hasPrev = () => currentPage > 1;

  const hasNext = () => currentPage < allPages;

  const getJumpPrevPage = () => Math.max(1, currentPage - 5);

  const getJumpNextPage = () => Math.min(allPages, currentPage + 5);

  const jumpPrev = () => {
    handleChange(getJumpPrevPage());
  };

  const jumpNext = () => {
    handleChange(getJumpNextPage());
  };

  const jumpPrevNode = (
    <div key="prev" onClick={jumpPrev} title="Previous 5 Pages" className="c-pagination_ellipsis">
      ...
    </div>
  );

  const jumpNextNode = (
    <div key="next" onClick={jumpNext} title="Next 5 Pages" className="c-pagination_ellipsis">
      ...
    </div>
  );

  const renderPagers = () => {
    const localPageList = [];

    if (allPages <= 3 + pageBufferSize * 2) {
      for (let i = 1; i <= allPages; i += 1) {
        localPageList.push(<Pager key={i} page={i} active={currentPage === i} onClick={handleChange} />);
      }
    } else {
      let left = Math.max(1, currentPage - pageBufferSize);
      let right = Math.min(currentPage + pageBufferSize, allPages);

      if (currentPage - 1 <= pageBufferSize) {
        right = 1 + pageBufferSize * 2;
      }

      if (allPages - currentPage <= pageBufferSize) {
        left = allPages - pageBufferSize * 2;
      }

      for (let i = left; i <= right; i += 1) {
        localPageList.push(<Pager key={i} page={i} active={currentPage === i} onClick={handleChange} />);
      }

      if (currentPage - 1 >= pageBufferSize * 2 && currentPage !== 1 + 2) {
        localPageList.unshift(jumpPrevNode);
      }
      if (allPages - currentPage >= pageBufferSize * 2 && currentPage !== allPages - 2) {
        localPageList[localPageList.length - 1] = React.cloneElement(localPageList[localPageList.length - 1]);
        localPageList.push(jumpNextNode);
      }

      if (left !== 1) {
        localPageList.unshift(<Pager key={1} page={1} onClick={handleChange} />);
      }
      if (right !== allPages) {
        localPageList.push(<Pager key={allPages} page={allPages} onClick={handleChange} />);
      }
    }
    return localPageList;
  };

  return (
    <div className="c-pagination">
      <Button
        type="outline"
        className="c-pagination-button-parent"
        onClick={() => hasPrev() && handleChange(currentPage - 1)}
      >
        <span
          className={clsx(
            'icon-16-chevron-left-mono c-pagination__button',
            currentPage === 1 && 'c-pagination__button--inactive'
          )}
        ></span>
      </Button>

      {renderPagers()}

      <Button
        type="outline"
        className="c-pagination-button-parent"
        onClick={() => hasNext() && handleChange(currentPage + 1)}
      >
        <span
          className={clsx(
            'icon-16-chevron-right-mono c-pagination__button',
            currentPage === allPages && 'c-pagination__button--inactive'
          )}
        ></span>
      </Button>
    </div>
  );
}

function Pager({ page, active = false, onClick }) {
  const handleClick = () => {
    onClick(page);
  };

  return (
    <div onClick={handleClick} className={clsx('c-pagination__page', active && 'c-pagination__page--active')}>
      {page}
    </div>
  );
}
